import LetterHead from "./LetterHead";
import ContactMailPhone from "./ContactMailPhone";
import { useLingui } from "@lingui/react";
import { getDocumentTranslator } from "../Document/documentLanguage";

const ContractContactInfo = ({ description, addressOnly, contractPartyDescription, isCustomer, withPartner, profile, language, translator }) => {
  const { i18n } = useLingui();
  const t = translator || getDocumentTranslator(i18n, language);
  const styles = {
    additionalInfo: {
      fontSize: 12,
    },
    name: {
      fontSize: "0.9rem",
      color: "#000000",
      textAlign: "left",
      height: "unset",
    },
  };

  return (
    <>
      <LetterHead isCustomer={isCustomer} withPartner={withPartner} />
      {!addressOnly && <ContactMailPhone isCustomer={isCustomer} withPartner={withPartner} language={language} />}
      <br />
      {!addressOnly && description && (
        <span style={styles.additionalInfo}>
          <div style={{ marginBottom: 5 }}>{description}</div>
        </span>
      )}
      {/* {withPartner && <ContactPartnerInfo />} */}
      <div style={{ marginTop: 10 }}>
        {t("hereinafterCalledPrefix")} {contractPartyDescription}
        {t("hereinafterCalledSuffix")}
      </div>
    </>
  );
};

export default ContractContactInfo;
